import React, { PureComponent } from 'react';
import {
  string,
  number,
  shape,
  oneOfType,
  element,
  func,
  bool,
} from 'prop-types';
import CopyToClipboard from 'react-copy-to-clipboard';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';
import T from '../Text';
import Clipboard from './Clipboard';
import { reduceClasses } from '../utils/testUtils';

const styles = {
  wrapper: {
    width: 'auto',
    display: 'inline-block',
    position: 'relative',
    color: '#222222',
    cursor: 'pointer',
    '& span': {
      fontSize: '13px !important',
    },
    '& > svg': { marginRight: '7px' },
  },
  'tooltip-wrapper': {
    zIndex: -1,
    display: 'block',
    position: 'absolute',
    top: '-72px',
    right: '0',
    opacity: 0,
    transition: 'all 0.8s ease',
  },
  'show-toolTip': {
    zIndex: 9999,
    opacity: 1,
  },
  tooltip: {
    width: '70px',
    borderRadius: '3px',
    backgroundColor: '#222',
    '& > span': { color: '#fff' },
    lineHeight: '16px',
    padding: '6px 0 7px',
    textAlign: 'center',
  },
  arrow: {
    width: 0,
    height: 0,
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderTop: '10px solid #222',
    margin: 'auto',
  },
};

/** Component to copy any text to the clipboard */
class CopyButton extends PureComponent {
  state = {
    showToolTip: false,
  };

  handleOnCopy = (text, result) => {
    const { onAfterCopy, dev } = this.props;

    if (dev) console.log('handle copy', text, result);
    if (result) {
      this.setState({ showToolTip: true }, () => {
        setTimeout(() => this.setState({ showToolTip: false }), 800);
        if (onAfterCopy) onAfterCopy(text);
      });
    } else if (dev) console.log('cant copy to clipboard', text, result);
  };

  render() {
    const { showToolTip } = this.state;
    const {
      dev,
      textToCopy,
      messageAfterCopy,
      classes: classesProp,
      wrapperStyles,
      tooltipStyles,
      tooltipWrapperStyles,
      children,
      iconSize,
      test,
    } = this.props;
    const classes = test ? reduceClasses(classesProp) : classesProp;

    if (dev) console.log('rendering CopyButton', this);

    return (
      <CopyToClipboard text={textToCopy} onCopy={this.handleOnCopy}>
        <div className={classes.wrapper} style={wrapperStyles}>
          <Clipboard size={iconSize} />
          {children}
          <div
            className={classNames(
              classes['tooltip-wrapper'],
              showToolTip && classes['show-toolTip'],
            )}
            style={tooltipWrapperStyles}
          >
            <div className={classes.tooltip} style={tooltipStyles}>
              <T test={test}>{messageAfterCopy}</T>
            </div>
            <div
              className={classes.arrow}
              style={{
                borderTopColor: tooltipStyles.backgroundColor,
              }}
            />
          </div>
        </div>
      </CopyToClipboard>
    );
  }
}

CopyButton.propTypes = {
  iconSize: number,
  textToCopy: string.isRequired,
  messageAfterCopy: string,
  onAfterCopy: func,
  classes: shape({}).isRequired,
  wrapperStyles: shape({}),
  tooltipStyles: shape({}),
  tooltipWrapperStyles: shape({}),
  children: oneOfType([string, element]),
  /** Useful for debug */
  dev: bool,
  /** Useful for snapshot testing. */
  test: bool,
};

CopyButton.defaultProps = {
  onAfterCopy: undefined,
  children: '',
  messageAfterCopy: '¡Link Copiado!',
  wrapperStyles: {},
  tooltipStyles: {},
  tooltipWrapperStyles: {},
  dev: false,
  iconSize: 12,
  test: false,
};

export default withStyles(styles, { name: 'copy-button' })(CopyButton);
